// AUTO-GENERATED from the legacy WordPress service pages by tools/wp-import/build-data.mjs.
// Images are mirrored to Supabase Storage. Do not edit by hand — re-run the generator.
export const SERVICE_PAGE_GROUPS = ["Construction & Renovation","Concrete","Structure & Trades","Finishes","Exterior & Site"];

export const SERVICE_PAGES = [
  {
    "slug": "additions",
    "name": "Additions",
    "group": "Construction & Renovation",
    "intro": "At MRE Developments , we transform your home with expertly crafted additions designed to enhance space , comfort , and value . From expanding living areas to creating seamless connections like a beautifully integrated Breezeway , our skilled team ensures every project blends flawlessly with your home’s existing structure. With a commitment to quality , functionality , and custom design , we deliver addition solutions that elevate your lifestyle and bring your vision to life .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/752-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/752-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/751-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/753-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/754-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/756-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/755-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/758-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/757-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/759-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7510-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7511-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7512-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7513-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7514-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7515-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7516-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7517-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7518-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7519-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7520-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/752.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/751.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/753.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/754.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/756.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/755.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/758.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/757.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/759.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7510.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7511.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7512.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7513.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7514.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7515.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7516.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7517.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7518.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7519.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/01/7520.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Additions Services"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Home Addition Services"
      },
      {
        "type": "p",
        "text": "1. Full Home Additions MRE Developments specializes in complete home additions, seamlessly expanding your living space. From initial planning to final construction, we ensure every project meets high standards of quality, functionality, and aesthetic appeal."
      },
      {
        "type": "p",
        "text": "2. Custom Addition Design We create additions tailored to your home and lifestyle. Collaborating with clients and architects, we design spaces that enhance flow, maximize natural light, and maintain harmony with the existing structure."
      },
      {
        "type": "p",
        "text": "3. Breezeways & Connecting Spaces Our team builds beautifully integrated Breezeways and other connecting structures that link new additions to your home, providing convenience, style, and improved accessibility."
      },
      {
        "type": "p",
        "text": "4. Room Extensions & Specialized Spaces Whether it’s a larger living room, new bedroom, sunroom, or home office, we construct high-quality, functional extensions that elevate comfort and usability."
      },
      {
        "type": "p",
        "text": "5. Renovation & Structural Enhancements We handle structural adjustments, reinforcement, and upgrades necessary for safe, long-lasting additions, ensuring durability and compliance with all building codes."
      },
      {
        "type": "p",
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "list",
        "items": [
          "Skilled Craftsmanship: Experienced professionals delivering reliable results.",
          "Quality Materials: Premium materials for lasting durability and finish.",
          "Client-Focused: Clear communication and satisfaction-driven service.",
          "On-Time Delivery: Efficient project completion with minimal disruption."
        ]
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/additions/"
  },
  {
    "slug": "bathroom-renovations",
    "name": "Bathroom renovation installation",
    "group": "Construction & Renovation",
    "intro": "At MRE Developments , we specialize in creating luxurious and functional bathrooms tailored to your unique needs. Whether you’re planning a full renovation , a custom design , or accessible solutions , our expert team in Calgary delivers exceptional craftsmanship and high-quality results . Let us help you transform your bathroom into a space that combines comfort , style , and practicality .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-5-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-16-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130001-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130010-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130038-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130102-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124235-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124336-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124738-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124848-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210002-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210017-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210031-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210332-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240610_160002-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240610_160446-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240610_160659-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/IMG-20240613-WA0019.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-16.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130001.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130010.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130038.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20161025_130102.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124235.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124336.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124738.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241119_124848.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210002.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210017.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210031.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230405_210332.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240610_160002.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240610_160446.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240610_160659.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Bathroom Renovation Services"
      },
      {
        "type": "h",
        "level": 4,
        "text": "MRE Developments: Expert Bathroom Renovation Services in Calgary"
      },
      {
        "type": "p",
        "text": "At MRE Developments, we understand that the bathroom is one of the most important spaces in your home. It’s where you start and end your day, and it should be a place of comfort, functionality, and style. Our team of professionals specializes in transforming bathrooms into luxurious retreats that perfectly blend aesthetics with practicality."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Bathroom Services"
      },
      {
        "type": "p",
        "text": "1. Full Bathroom Renovations Whether you’re looking to completely overhaul your bathroom or make targeted upgrades, MRE Developments offers comprehensive renovation services. From concept to completion, we handle every aspect of your bathroom remodel, including design, plumbing, tiling, and fixture installation. Our goal is to create a space that reflects your personal style while maximizing functionality."
      },
      {
        "type": "p",
        "text": "2. Custom Bathroom Design Every bathroom should be unique, just like its owner. Our custom bathroom design services allow you to create a space that meets your specific needs and preferences. We work closely with you to select the perfect materials, fixtures, and finishes, ensuring that every detail aligns with your vision."
      },
      {
        "type": "p",
        "text": "3. Tile and Flooring Installation Quality flooring and tiling are essential for both the look and durability of your bathroom. Our skilled installers use high-quality materials and precise techniques to ensure that your bathroom floors and walls are not only beautiful but also long-lasting and easy to maintain."
      },
      {
        "type": "p",
        "text": "4. Fixture Installation Whether you’re updating your bathroom with modern fixtures or need a complete installation for a new build, MRE Developments provides expert fixture installation services. From sinks and faucets to showers and bathtubs, we ensure that every component is installed to the highest standards."
      },
      {
        "type": "p",
        "text": "5. Accessible Bathrooms Creating accessible bathrooms is a key service we offer at MRE Developments. We design and install bathrooms that are functional and safe for everyone, including those with mobility challenges. Our accessible designs include walk-in showers, grab bars, non-slip flooring, and more, ensuring that your bathroom is comfortable and usable for all."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "list",
        "items": [
          "Expert Craftsmanship: Our team brings years of experience and a keen eye for detail to every bathroom project, ensuring exceptional results.",
          "High-Quality Materials: We source the best materials to ensure that your bathroom is both stunning and durable.",
          "Customer Satisfaction: Your satisfaction is our top priority. We work closely with you to ensure that the final result meets your expectations and enhances your home.",
          "Timely Project Completion: We respect your time and ensure that your bathroom renovation is completed on schedule, with minimal disruption to your daily life."
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "Get Started on Your Dream Bathroom"
      },
      {
        "type": "p",
        "text": "Ready to transform your bathroom? Contact MRE Developments today to discuss your project and receive a free consultation. Let’s create a bathroom that combines luxury, comfort, and practicality, tailored specifically for you."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/bathroom-renovations/"
  },
  {
    "slug": "full-home-renovation-service-2",
    "name": "FULL HOME RENOVATION Service",
    "group": "Construction & Renovation",
    "intro": "At MRE Developments , our end-to-end home renovation service is designed to transform your entire living space into a stylish, functional, and modern home . From initial consultation and layout redesign to structural updates , plumbing and electrical upgrades , new finishes , and final detailing , we manage every step with care so you don’t have to coordinate multiple contractors. With a focus on quality craftsmanship , clear communication , and tailored design , we ensure the end result not only fulfills your vision but also adds lasting value and enhanced comfort to your home.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/1-1-4.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/1-1-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/2-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/3-1-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/4-1.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/5-1-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/6-1.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/7-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/8-1.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/9-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/10-1.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/11-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/10/12-1.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/1-6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/2-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/3-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/4-15-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/5-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/6-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/7-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/8-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/9-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/10-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/11-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/12-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/2-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/3-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/4-14-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/7-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/8-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/9-1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/10-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/11-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/12-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/13-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/14-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/1-6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/2-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/3-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/4-15.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/5-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/6-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/7-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/8-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/9-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/10-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/11-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/12/12-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/2-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/3-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/4-14.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/7-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/8-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/9-1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/10-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/11-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/12-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/13-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/14-1.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Full Home Renovation Services"
      },
      {
        "type": "p",
        "text": "Our full home renovation covers everything from design, structural changes, plumbing, and electrical upgrades to flooring, painting, and interiors. We handle every detail—from planning to finishing—to deliver a modern, functional, and beautifully transformed home."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/full-home-renovation-service-2/"
  },
  {
    "slug": "kitchen-renovation-services",
    "name": "KITCHEN RENOVATION SERVICES",
    "group": "Construction & Renovation",
    "intro": "At MRE Developments , we specialize in creating beautiful, functional kitchens tailored to your unique needs. Whether you’re planning a complete kitchen renovation , a custom kitchen design , or a modern upgrade , our expert team in Calgary delivers exceptional craftsmanship and high-quality results . Let us help you transform your kitchen into a space that combines style, functionality, and lasting value .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/FB_IMG_1754278772904.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/FB_IMG_1754278772904.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/f8b21d2acdc10f354adb1277e6d9396a.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/76da2b4e4ae86da1e59570899baf1b7d.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/9a3e78eb18370a5b214faf696991db57.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/2d76c9dc8d59e6e3379c88f80c6ee813.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c15-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c16-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c17-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c18-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/1-9-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/2-8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/3-7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/Screenshot_20181027-134741_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/Screenshot_20181027-134727_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/Screenshot_20181027-134704_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c15.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c16.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c17.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/c18.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/1-9.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/2-8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/3-7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/07/4-1.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 1,
        "text": "MRE Developments: Expert Kitchen Renovation Services in Calgary"
      },
      {
        "type": "p",
        "text": "At MRE Developments , we understand that the kitchen is the heart of your home . It’s where meals are prepared, memories are made, and family and friends come together. Your kitchen should be a space that combines style, functionality, and efficiency . Our experienced team specializes in transforming outdated kitchens into beautiful, modern spaces designed to suit your lifestyle and enhance the value of your home."
      },
      {
        "type": "h",
        "level": 2,
        "text": "Our Kitchen Services"
      },
      {
        "type": "h",
        "level": 3,
        "text": "1. Full Kitchen Renovations"
      },
      {
        "type": "p",
        "text": "Whether you’re planning a complete kitchen makeover or looking to upgrade specific features, MRE Developments offers comprehensive kitchen renovation services. From the initial design consultation to the final installation, we manage every aspect of your project, including cabinetry, countertops, flooring, lighting, plumbing, electrical work, and appliance installation. Our goal is to create a kitchen that is both visually stunning and highly functional."
      },
      {
        "type": "h",
        "level": 3,
        "text": "2. Custom Kitchen Design"
      },
      {
        "type": "p",
        "text": "Every homeowner has a unique vision for their dream kitchen. Our custom kitchen design services allow you to create a space tailored to your needs, cooking habits, and personal style. We work closely with you to select the ideal layout, cabinets, countertops, backsplashes, fixtures, and finishes, ensuring every detail reflects your preferences while maximizing space and efficiency."
      },
      {
        "type": "h",
        "level": 3,
        "text": "3. Cabinet Installation & Refacing"
      },
      {
        "type": "p",
        "text": "Cabinets are one of the most important features of any kitchen. Whether you want brand-new custom cabinetry or a cost-effective cabinet refacing solution, our team delivers expert craftsmanship and precision installation. We help you achieve a fresh, modern look while improving storage and organization."
      },
      {
        "type": "h",
        "level": 3,
        "text": "4. Countertop, Backsplash & Flooring Installation"
      },
      {
        "type": "p",
        "text": "Enhance the beauty and durability of your kitchen with professionally installed countertops, backsplashes, and flooring . We work with a wide range of premium materials, including quartz, granite, tile, luxury vinyl, and hardwood, ensuring long-lasting performance and a polished finish that complements your design."
      },
      {
        "type": "h",
        "level": 3,
        "text": "5. Kitchen Fixture & Appliance Installation"
      },
      {
        "type": "p",
        "text": "From sinks and faucets to lighting fixtures and kitchen appliances, MRE Developments provides professional installation services to ensure every component functions perfectly. We install each feature with precision, creating a kitchen that is efficient, comfortable, and ready for everyday use."
      },
      {
        "type": "h",
        "level": 2,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "list",
        "items": [
          "Expert Craftsmanship: Our experienced professionals deliver outstanding workmanship with careful attention to every detail.",
          "High-Quality Materials: We use premium materials and trusted products to create kitchens that are both beautiful and built to last.",
          "Customer Satisfaction: Your vision is our priority. We collaborate with you throughout the renovation process to ensure the finished kitchen exceeds your expectations.",
          "Timely Project Completion: We complete projects on schedule while minimizing disruptions to your daily routine, so you can enjoy your new kitchen as soon as possible."
        ]
      },
      {
        "type": "h",
        "level": 2,
        "text": "Get Started on Your Dream Kitchen"
      },
      {
        "type": "p",
        "text": "Ready to transform your kitchen? Contact MRE Developments today to schedule your free consultation . Let our team design and build a kitchen that perfectly blends beauty, functionality, and lasting value , tailored to your unique lifestyle."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/kitchen-renovation-services/"
  },
  {
    "slug": "new-home-construction-services",
    "name": "New Home Construction Services",
    "group": "Construction & Renovation",
    "intro": "Building a new home or multi-unit development is one of the largest investments you’ll ever make. The right planning , team , and execution can mean the difference between a project that stays on budget and on schedule , and one that becomes filled with delays , change orders , and uncertainty .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd2.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd9-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk10-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk11-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de2-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de3-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de4-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de5-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de6-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de7-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de8-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/yy8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/sd9.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk10.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/lk11.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de2-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de3-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de4-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de5-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de6-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de7-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/de8-1.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "New Home Construction Services (Single-Family & Multi-Unit Homes)"
      },
      {
        "type": "p",
        "text": "At MRE Developments , we provide complete new home construction services for homeowners , investors , and developers throughout Calgary ."
      },
      {
        "type": "p",
        "text": "From custom single-family homes and infill developments to duplexes , fourplexes , and multi-unit residential projects , we help clients navigate every stage of the construction process with confidence."
      },
      {
        "type": "p",
        "text": "Our goal isn’t simply to build structures . Our goal is to help clients create high-quality homes and residential developments that maximize value , minimize risk , and stand the test of time . Whether you’re building your family’s dream home , creating a rental property , or developing a multi-unit investment project , our team provides the planning , construction expertise , and project management needed to bring your vision to life."
      },
      {
        "type": "h",
        "level": 2,
        "text": "New Home Construction Services In Calgary"
      },
      {
        "type": "h",
        "level": 3,
        "text": "Custom Single-Family Homes"
      },
      {
        "type": "p",
        "text": "Every homeowner has a unique vision for how they want to live."
      },
      {
        "type": "p",
        "text": "We work closely with clients to design and construct custom homes that reflect their lifestyle, priorities, and long-term goals. From modern family homes to high-end custom residences, our focus is on delivering quality craftsmanship, functional layouts, and lasting value."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Duplex & Semi-Detached Construction"
      },
      {
        "type": "p",
        "text": "Duplexes continue to be one of Calgary’s most attractive housing and investment opportunities."
      },
      {
        "type": "p",
        "text": "Whether you’re building for personal use, resale, or rental income, we provide complete construction services designed to maximize both functionality and return on investment."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Fourplex & Multi-Unit Residential Construction"
      },
      {
        "type": "p",
        "text": "As Calgary continues to grow, demand for well-designed multi-unit housing continues to increase."
      },
      {
        "type": "p",
        "text": "We help investors and developers build fourplexes and other multi-family residential projects that maximize land use, increase revenue potential, and create long-term value while maintaining high construction standards."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Infill Home Construction"
      },
      {
        "type": "p",
        "text": "Many of Calgary’s most desirable communities offer excellent opportunities for infill development."
      },
      {
        "type": "p",
        "text": "Our team specializes in transforming underutilized lots into modern, efficient homes that complement existing neighbourhoods while maximizing property value."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Design, Drafting & Permit Coordination"
      },
      {
        "type": "p",
        "text": "Every successful construction project begins with proper planning."
      },
      {
        "type": "p",
        "text": "We assist clients with design development, drafting, engineering coordination, permit applications, and municipal approvals to ensure projects move efficiently from concept to construction."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Full Project Management"
      },
      {
        "type": "p",
        "text": "Successful projects require more than construction alone."
      },
      {
        "type": "p",
        "text": "They require effective coordination between designers, engineers, municipalities, inspectors, suppliers, and skilled trades."
      },
      {
        "type": "p",
        "text": "Our team manages every stage of the construction process to help ensure quality workmanship, efficient scheduling, and a smoother building experience."
      },
      {
        "type": "h",
        "level": 2,
        "text": "Built For Homeowners, Investors & Developers"
      },
      {
        "type": "p",
        "text": "Every construction project has different objectives."
      },
      {
        "type": "p",
        "text": "For homeowners, the priority may be creating a home that meets their family’s needs for years to come."
      },
      {
        "type": "p",
        "text": "For investors, the priority may be maximizing rental income and long-term returns."
      },
      {
        "type": "p",
        "text": "For developers, success often depends on balancing construction costs, timelines, and market demand."
      },
      {
        "type": "p",
        "text": "Our experience working with a wide range of residential projects allows us to understand these different priorities and provide solutions tailored to each client’s goals."
      },
      {
        "type": "h",
        "level": 2,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "h",
        "level": 3,
        "text": "A Proactive Approach To Construction"
      },
      {
        "type": "p",
        "text": "Many contractors simply build what is shown on the plans."
      },
      {
        "type": "p",
        "text": "We take a more proactive approach."
      },
      {
        "type": "p",
        "text": "Our team works to identify potential challenges early, coordinate closely with designers and engineers, and find practical solutions that help reduce delays, avoid unnecessary costs, and keep projects moving forward."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Local Calgary Expertise"
      },
      {
        "type": "p",
        "text": "We understand Calgary’s building requirements, permit processes, development regulations, and construction standards."
      },
      {
        "type": "p",
        "text": "This local knowledge helps projects move more efficiently while reducing costly surprises throughout the building process."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Quality Craftsmanship"
      },
      {
        "type": "p",
        "text": "Quality construction is an investment in the future."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/new-home-construction-services/"
  },
  {
    "slug": "secondary-suites-legal-basement-rental-suites",
    "name": "Secondary Suites – Legal Basement & Rental Suites",
    "group": "Construction & Renovation",
    "intro": "At MRE Developments , we specialize in designing and building secondary suites in Calgary that add value , comfort , and rental income potential to your property. Whether you’re planning a legal basement suite , a garage suite , or a laneway home , our team delivers expert craftsmanship with full compliance to Calgary’s bylaws and building codes .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q5-1.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q5-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/2-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/4-12-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/5-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/8-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/9-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/10-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/11-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/12-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/13-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/14-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/15-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/16-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q5-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/3-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/6-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/7-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/8-1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/10-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/12-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/13-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/5-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/6-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/7-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/8-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/9-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/10-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/11-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/12-5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/13-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/14-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/15-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/16-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/19-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/20-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/21-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/22-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/2-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/4-12.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/5-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/8-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/9-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/10.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/11-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/12-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/13.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/14.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/15-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/16-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q5-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/q6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/3-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tt8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/kka8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/5-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/6-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/7-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/8-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/9-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/10-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/11-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/12-5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/13-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/14-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/15-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/16-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/19.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/20.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/21.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/22.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Secondary Suites- Legal Basement Suites & Rental Suites (Garage Suites, Backyard Suites)"
      },
      {
        "type": "p",
        "text": "From homeowners wanting extra family space to investors seeking reliable basement apartment construction in Calgary, we provide functional , modern , and safe solutions tailored to your goals."
      },
      {
        "type": "h",
        "level": 2,
        "text": "Our Calgary Secondary Suites- Legal Basement Suites & Rental Suites (Garage Suites, Backyard Suites)"
      },
      {
        "type": "p",
        "text": "1. Basement Secondary Suites"
      },
      {
        "type": "p",
        "text": "Maximize unused space with a legal basement suite in Calgary. We handle everything — from permits and suite design to construction and finishing. Our basement apartments are built to meet Calgary’s safety standards, providing you with a modern, code-compliant living unit perfect for tenants or family"
      },
      {
        "type": "p",
        "text": "2 . Garage & Laneway Suites"
      },
      {
        "type": "p",
        "text": "Looking for extra income or a private guest home? A garage suite or laneway home in Calgary offers a smart solution. These units expand property value and provide a fully independent rental space without taking away from your main home"
      },
      {
        "type": "p",
        "text": "3.Custom Secondary Suite Design & Construction"
      },
      {
        "type": "p",
        "text": "As a leading secondary suite builder in Calgary, we design suites around your property’s unique layout. From floor plans and kitchens to private bathrooms and separate entrances, our team ensures your suite is functional, stylish, and aligned with your vision"
      },
      {
        "type": "p",
        "text": "Already have a suite that needs work? We bring older basement apartments and secondary suites up to code. Our renovation services include safety improvements, structural fixes, new finishes, and energy-efficient upgrades — ensuring your rental unit is attractive, durable, and fully legal."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments for Your Calgary Secondary Suite?"
      },
      {
        "type": "p",
        "text": "Local Calgary Expertise : We understand secondary suite bylaws, zoning rules, and the city’s permit process."
      },
      {
        "type": "p",
        "text": "Legal & Code-Compliant Builds: Every basement suite construction project meets or exceeds Calgary’s legal requirements."
      },
      {
        "type": "p",
        "text": "Durable, Quality Construction: Built to last with premium materials and expert craftsmanship."
      },
      {
        "type": "p",
        "text": "Investor-Friendly Solutions: Designed to maximize rental income potential while staying on budget."
      },
      {
        "type": "p",
        "text": "On-Time Delivery : Projects completed efficiently without compromising quality."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Work Speaks for Itself"
      },
      {
        "type": "p",
        "text": "Explore our gallery of secondary suite projects in Calgary — from legal basement suites to laneway homes. Our proven craftsmanship ensures your property gains value, functionality, and compliance with city regulations."
      },
      {
        "type": "p",
        "text": "👉 Unlock your property’s full potential with MRE Developments – Calgary’s trusted secondary suite builder. Contact us today for a free consultation on your basement suite or secondary suite project in Calgary"
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/secondary-suites-legal-basement-rental-suites/"
  },
  {
    "slug": "side-entries-separate-entries-2",
    "name": "Secondary Suites – Legal Basement & Rental Suites",
    "group": "Construction & Renovation",
    "intro": "At MRE Developments, we specialize in designing and building secondary suites in Calgary that add value, comfort, and rental income potential to your property. Whether you’re planning a legal basement suite, a garage suite, or a laneway home, our team delivers expert craftsmanship with full compliance to Calgary’s bylaws and building codes.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/4-4.png",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/4-4.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/4-3.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/3-3.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/2-4.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/1-4.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/4-2.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/3-2.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/2-3.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/c.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/b.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/09/a.png"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "From homeowners wanting extra family space to investors seeking reliable basement apartment construction in Calgary, we provide functional, modern, and safe solutions tailored to your goals."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Our Calgary Secondary Suite Services"
      },
      {
        "type": "list",
        "items": [
          "Basement Secondary Suites"
        ]
      },
      {
        "type": "p",
        "text": "Maximize unused space with a legal basement suite in Calgary. We handle everything — from permits and suite design to construction and finishing. Our basement apartments are built to meet Calgary’s safety standards, providing you with a modern, code-compliant living unit perfect for tenants or family."
      },
      {
        "type": "list",
        "items": [
          "Garage & Laneway Suites"
        ]
      },
      {
        "type": "p",
        "text": "Looking for extra income or a private guest home? A garage suite or laneway home in Calgary offers a smart solution. These units expand property value and provide a fully independent rental space without taking away from your main home."
      },
      {
        "type": "list",
        "items": [
          "Custom Secondary Suite Design & Construction"
        ]
      },
      {
        "type": "p",
        "text": "As a leading secondary suite builder in Calgary, we design suites around your property’s unique layout. From floor plans and kitchens to private bathrooms and separate entrances, our team ensures your suite is functional, stylish, and aligned with your vision."
      },
      {
        "type": "list",
        "items": [
          "Suite Renovations & Upgrades"
        ]
      },
      {
        "type": "p",
        "text": "Already have a suite that needs work? We bring older basement apartments and secondary suites up to code. Our renovation services include safety improvements, structural fixes, new finishes, and energy-efficient upgrades — ensuring your rental unit is attractive, durable, and fully legal."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments for Your Calgary Secondary Suite?"
      },
      {
        "type": "p",
        "text": "Local Calgary Expertise : We understand secondary suite bylaws, zoning rules, and the city’s permit process."
      },
      {
        "type": "p",
        "text": "Legal & Code-Compliant Builds: Every basement suite construction project meets or exceeds Calgary’s legal requirements."
      },
      {
        "type": "p",
        "text": "Durable, Quality Construction: Built to last with premium materials and expert craftsmanship."
      },
      {
        "type": "p",
        "text": "Investor-Friendly Solutions: Designed to maximize rental income potential while staying on budget."
      },
      {
        "type": "p",
        "text": "On-Time Delivery : Projects completed efficiently without compromising quality."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Work Speaks for Itself"
      },
      {
        "type": "p",
        "text": "Explore our gallery of secondary suite projects in Calgary — from legal basement suites to laneway homes. Our proven craftsmanship ensures your property gains value, functionality, and compliance with city regulations."
      },
      {
        "type": "p",
        "text": "👉 Unlock your property’s full potential with MRE Developments – Calgary’s trusted secondary suite builder. Contact us today for a free consultation on your basement suite or secondary suite project in Calgary"
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/side-entries-separate-entries-2/"
  },
  {
    "slug": "side-entries-separate-entries",
    "name": "Side Entries & Separate Entries",
    "group": "Construction & Renovation",
    "intro": "At MRE Developments , we specialize in side entries and separate entries tailored to your specific project needs. We install side entries for secondary suites as well as for homeowners renovating their homes who need to upgrade access points . With engineers and designers on our team, we manage planning and City of Calgary permit approvals to ensure full compliance. Our expert team in Calgary delivers high-quality results with precision, efficiency, and attention to detail.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq1-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq7-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq8-7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240628_154918-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_092404-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_093054-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_100612-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_115838-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_124224-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_134817-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241015_171931-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq7-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/qq8-7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240628_154918-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_092404-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_093054.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_100612.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_115838.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_124224.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20240916_134817.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20241015_171931.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/kk8.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 3,
        "text": "Premier Side Entry & Separate Entry Services in Calgary"
      },
      {
        "type": "p",
        "text": "At MRE Developments, we specialize in building high-quality side entries and basement separate entries in Calgary. Whether you’re a homeowner looking to improve accessibility, or an investor wanting to create a legal secondary suite entry for rental income, our team delivers solutions that combine functionality, safety, and style."
      },
      {
        "type": "p",
        "text": "Our skilled builders focus on precision and durability, ensuring every project is completed to the highest standards and compliant with all Calgary building codes."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Side Entry & Separate Entry Services"
      },
      {
        "type": "p",
        "text": "1. Residential Side Entries"
      },
      {
        "type": "p",
        "text": "Upgrade your home with a custom side entry in Calgary that adds convenience and enhances curb appeal. From mudroom access points to private side doors, we design and construct entries that blend seamlessly with your home’s structure while improving daily functionality."
      },
      {
        "type": "p",
        "text": "2. Basement Separate Entries for Secondary Suites"
      },
      {
        "type": "p",
        "text": "Increase the value and income potential of your property with a basement separate entry for rental secondary suites. We ensure your new entry is fully code-compliant, safe, and attractive. Whether you’re creating a legal basement secondary suite or improving accessibility to an existing rental, our solutions help you maximize return on investment."
      },
      {
        "type": "p",
        "text": "3. Custom Entry Design & Construction"
      },
      {
        "type": "p",
        "text": "Every home is unique, and so is each entry project. Our custom entryway construction allows you to choose layouts, doors, steps, and finishes that suit your property’s design. Whether you want a modern, discreet entry or a bold architectural feature, MRE Developments tailors every project to your vision."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments for Your Side Entry Project?"
      },
      {
        "type": "list",
        "items": [
          "Local Calgary Expertise: We understand the city’s bylaws, building codes, and permit requirements for side entries and basement suite entries.",
          "Durable, Quality Construction: Built to last using premium materials and proven techniques.",
          "Code-Compliant & Safe: All projects meet or exceed Calgary safety standards.",
          "Customer-Focused Approach: We work closely with you to design and deliver exactly what your property needs.",
          "On-Time, On-Budget Project Delivery: Projects completed efficiently without compromising quality."
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Work Speaks for Itself"
      },
      {
        "type": "p",
        "text": "Explore our gallery of Calgary side entry and secondary suite entry projects. From sleek modern designs to functional rental suite entries, our craftsmanship ensures your property looks great while meeting all safety and code requirements."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/side-entries-separate-entries/"
  },
  {
    "slug": "concrete-cutting",
    "name": "CONCRETE CUTTING",
    "group": "Concrete",
    "intro": "At MRE Developments , our concrete cutting services deliver the same precision, expertise, and reliability that define all our work. Whether you’re renovating, expanding, or preparing for new installations, our skilled team uses advanced cutting equipment to create clean, accurate cuts in concrete surfaces of all types. We tailor our approach to meet the needs of both residential and commercial clients, ensuring minimal disruption and maximum efficiency. From controlled demolition to expansion joint cutting, we provide safe, precise, and dependable solutions that help lay the groundwork for your project’s success.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_140539-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_140539-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_120639-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_112503-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_110133-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_110123-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_101949-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_101207-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_095136-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_140539.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_120639.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_112503.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_110133.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_110123.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_101949.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_101207.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251108_095136.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Concrete Cutting Services"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Concrete Cutting Services"
      },
      {
        "type": "p",
        "text": "1. Residential Concrete Cutting Upgrade your home renovation projects with our precise concrete cutting solutions. From creating openings for doors and windows to modifying slabs for plumbing or electrical work, we deliver clean, accurate cuts using advanced equipment. Our team works safely and efficiently to support your project with minimal disruption."
      },
      {
        "type": "p",
        "text": "2. Commercial Concrete Cutting MRE Developments provides dependable concrete cutting for commercial and industrial projects. Whether you need floor sawing for new utilities or wall cutting for structural upgrades, we handle every job with accuracy and professionalism. We prioritize safety and timelines to keep your project moving smoothly."
      },
      {
        "type": "p",
        "text": "3. Specialized Concrete Cutting & Drilling For unique or complex needs, our specialized services include core drilling, expansion joint cutting, and controlled demolition. Using state-of-the-art tools, we ensure every cut is precise and tailored to your project requirements. Our expertise guarantees smooth, controlled results every time."
      },
      {
        "type": "p",
        "text": "4. Concrete Removal & Surface Preparation Once the cutting is complete, we also manage concrete removal and surface prep to ready your space for the next phase. We safely clear debris and leave the area clean and construction-ready. Our process ensures a solid foundation for new installations or upgrades."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/concrete-cutting/"
  },
  {
    "slug": "concrete-floor-services",
    "name": "Concrete Floor Services",
    "group": "Concrete",
    "intro": "Whether you are looking to enhance your home’s curb appeal or upgrade your property value , our expert concrete flatwork services deliver the perfect balance of structural integrity & aesthetic precision . We specialize in high-quality sidewalks, driveways, basement floors, and garage floors designed to withstand the unique demands of the Calgary climate. From the clean, slip-resistant utility of a classic broom finish to the high-end look of decorative finishes —including the rugged texture of exposed aggregate & the custom patterns of stamped concrete —we provide tailored solutions that elevate your property. We combine thorough site preparation with professional finishing to ensure every slab is level , durable , and built to last for years to come.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110154-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110222-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110631-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110636-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_093755-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_102813-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_102946-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_103139-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175026-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175100-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175138-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175650-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110154.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110222.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110631.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191031_110636.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_093755.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_102813.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_102946.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/IMG_20191109_103139.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175026.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175100.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175138.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220923_175650.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Concrete Flatwork Services"
      },
      {
        "type": "p",
        "text": "In addition, our approach emphasizes precision grading , proper drainage solutions , and reinforcement techniques to maximize the longevity and performance of every surface. We utilize premium materials and adhere to industry best practices to ensure consistent quality and resilience in all conditions. Our team also prioritizes clear communication , project efficiency , and minimal disruption to your daily routine, delivering results that meet the highest standards of craftsmanship while exceeding client expectations."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/concrete-floor-services/"
  },
  {
    "slug": "concrete-foundations",
    "name": "CONCRETE FOUNDATIONS",
    "group": "Concrete",
    "intro": "At MRE Developments , we understand that a solid foundation is the cornerstone of every successful construction project. Our concrete foundation services are engineered for strength, stability, and long-lasting performance, ensuring your residential or commercial structure is built on a dependable base. Using high-quality materials and precise installation techniques, our skilled team delivers foundations that stand up to time, weather, and heavy loads. Whether you’re starting a new build or upgrading existing infrastructure, we provide reliable solutions you can trust from the ground up.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180115_121727-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180115_121727-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180115_121720-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180115_120952-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20180115_121845-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180115_121727.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180115_121720.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180115_120952.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20180115_121845.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Concrete Foundation Services"
      },
      {
        "type": "h",
        "level": 2,
        "text": "Our Concrete Foundation Services"
      },
      {
        "type": "p",
        "text": "MRE Developments delivers complete foundation construction for residential and commercial projects. From excavation to concrete finishing, we ensure a strong, durable, and code-compliant foundation every time."
      },
      {
        "type": "p",
        "text": "We design foundations tailored to your building’s structural needs. Working with engineers and clients, we create solutions that maximize strength, stability, and long-term performance."
      },
      {
        "type": "p",
        "text": "Our team installs high-quality footings, slab-on-grade foundations, and grade beams using precise techniques and premium materials to ensure lasting stability."
      },
      {
        "type": "p",
        "text": "We provide reinforced concrete work for retaining walls, pads, and other structural elements that support loads, prevent soil movement, and protect your property."
      },
      {
        "type": "p",
        "text": "From cracking to settling issues, we offer effective repair and reinforcement services—restoring safety and extending the life of your foundation."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "list",
        "items": [
          "Skilled Craftsmanship: Experienced professionals delivering reliable results.",
          "Quality Materials: Durable, high-grade concrete and reinforcement.",
          "Client-Focused: Clear communication and satisfaction-driven service.",
          "On-Time Delivery: Efficient project completion with minimal disruption."
        ]
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/concrete-foundations/"
  },
  {
    "slug": "concrete-repairs-and-maintenance",
    "name": "Concrete Repairs and Maintenance",
    "group": "Concrete",
    "intro": "Extend the life of your existing concrete surfaces with our expert repair and maintenance services. We address cracks, wear, and other damages promptly, restoring the integrity and appearance of your concrete. Our maintenance plans are designed to prevent future issues, saving you time and money in the long run.",
    "hero": null,
    "gallery": [],
    "blocks": [],
    "sourceUrl": "https://calgary.mredevelopments.com/concrete-repairs-and-maintenance/"
  },
  {
    "slug": "concrete-services",
    "name": "Concrete Services",
    "group": "Concrete",
    "intro": "At MRE Developments , we specialize in providing top-tier concrete solutions tailored to meet the unique needs of both residential and commercial clients across Calgary . Our skilled team delivers precision , craftsmanship , and reliability on every project, ensuring results that not only meet but exceed expectations .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_150709-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_150709-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_150842-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_151138-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_151500-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240824_193528-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240821_165327-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240821_171721-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240821_183329-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_133144-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_140435-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_145232-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_145350-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251109_120703-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_133436-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_140247-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_141820-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240829_112428-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240903_163340-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_194437-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240929_124022-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251120_124225-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251120_124653-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251120_140954-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_154907-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_130035-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_133012-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_134311-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_142940-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_150709.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_150842.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_151138.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220810_151500.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240824_193528-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240821_165327.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240821_171721.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240821_183329.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_133144.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_140435.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_145232.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240914_145350-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251109_120703.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_133436.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_140247.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_141820.jpg",
      "https://calgary.mredevelopments.com/wp-content/uploads/2026/04/20240829_112428.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240903_163340.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_194437.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240929_124022.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251120_124225.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251120_124653.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251120_140954.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20251121_154907.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_130035.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_133012.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_134311.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20220830_142940.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4-4.jpg"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "From foundations to driveways , our concrete services are designed to provide durable and long-lasting solutions for your property. We use high-quality materials and advanced techniques to ensure that every concrete surface is strong, resilient, and built to last ."
      },
      {
        "type": "h",
        "level": 2,
        "text": "Our Concrete Services (Residential & Commercial)"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Concrete Cutting Services 📷"
      },
      {
        "type": "p",
        "text": "Enhance your construction or renovation project with our professional concrete cutting solutions. Whether you need precise openings for utilities, clean cuts for slabs and walls, or controlled removal of specific sections, we use advanced equipment and skilled techniques to ensure accuracy, safety, and minimal disruption Read More"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Concrete Foundation Services"
      },
      {
        "type": "p",
        "text": "Build your project on a strong, reliable base with our professional concrete foundation services. Whether you’re constructing a new home, adding an extension, or starting a commercial build, Read More"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Concrete Flatwork Services"
      },
      {
        "type": "p",
        "text": "Whether you are looking to enhance your home’s curb appeal or upgrade your property value , our expert concrete flatwork services deliver the perfect balance of structural integrity & aesthetic precision . Read More"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Custom Concrete/ Decorative Services"
      },
      {
        "type": "p",
        "text": "Every property is unique, and so are its concrete needs. Our custom concrete services allow you to bring your vision to life. Whether it’s a decorative concrete Read More"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Concrete Repairs and Maintenance"
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "list",
        "items": [
          "Expertise & Experience: With years of experience in the industry, we bring a wealth of knowledge and technical skills to every project.",
          "Quality Materials: We use only the best materials to ensure the longevity and durability of our work.",
          "Customer-Centric Approach: Your satisfaction is our priority. We collaborate with you throughout the project, ensuring that your vision is fully realized.",
          "Timely Execution: We understand the importance of timelines in construction. Our team is committed to delivering your project on schedule, without compromising on quality."
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Work Speaks for Itself"
      },
      {
        "type": "p",
        "text": "We invite you to explore our gallery to see the results of our recent projects. From expertly poured concrete patios to large commercial developments, our work is a testament to the quality and reliability that MRE Developments is known for in Calgary."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/concrete-services/"
  },
  {
    "slug": "custom-concrete-work",
    "name": "Custom Concrete Work",
    "group": "Concrete",
    "intro": "Every property is unique, and so are its concrete needs. Our custom concrete services allow you to bring your vision to life. Whether it’s a decorative concrete feature, stamped concrete designs, or specialized finishes, we deliver craftsmanship that reflects your style and preferences.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_134740-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_134740-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_141939-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_142441-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_152023-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_190602-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_193419-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_193608-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240929_123753-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4-3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/5-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/6-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/7-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/8-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_134740.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_141939.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_142441.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20250510_152023.jpg",
      "https://calgary.mredevelopments.com/wp-content/uploads/2026/04/1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-1.jpg",
      "https://calgary.mredevelopments.com/wp-content/uploads/2026/04/3-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/5.jpg",
      "https://calgary.mredevelopments.com/wp-content/uploads/2026/04/6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_190602.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_193419.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240905_193608.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/20240929_123753.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/4-3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/5-1.jpg",
      "https://calgary.mredevelopments.com/wp-content/uploads/2026/04/6-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/7-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/8-1.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Custom Concrete/ Decorative Services"
      },
      {
        "type": "p",
        "text": "Our team is committed to delivering reliable , efficient , and high-quality results on every project. From initial consultation and design planning to professional installation and final finishing , we ensure a smooth and transparent process. With a strong focus on timely project completion , budget control , and attention to detail , we deliver a finished product that enhances both the appearance , functionality , and long-term durability of your space."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/custom-concrete-work/"
  },
  {
    "slug": "epoxy-services",
    "name": "Epoxy Services",
    "group": "Concrete",
    "intro": "At MRE Developments , we provide professional epoxy flooring services designed to deliver durable , seamless , and visually appealing surfaces for residential and commercial spaces . Our epoxy coatings create a strong protective layer that resists stains , moisture , chemicals , and heavy foot traffic , making them ideal for garages , basements , workshops , and commercial environments . With precise surface preparation and high-quality materials , our skilled team ensures a smooth, long-lasting finish that enhances both the functionality and appearance of your floors.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr8-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/20220518_135015-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/A-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/B-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/C-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/D.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/tr6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/20220518_135015.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gf8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/df7.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Epoxy Flooring Services"
      },
      {
        "type": "p",
        "text": "At MRE Developments , we provide high-quality residential epoxy flooring solutions designed to enhance durability, style, and functionality. Our epoxy floors are perfect for garages, basements, kitchens, and utility areas, offering a seamless and easy-to-maintain surface."
      },
      {
        "type": "p",
        "text": "We specialize in garage epoxy floor coatings that protect your floors from stains, chemicals, moisture, and heavy wear. Our durable epoxy systems create a clean, polished look while improving the longevity of your garage floor."
      },
      {
        "type": "p",
        "text": "Our team installs commercial and industrial epoxy flooring designed for high-traffic environments such as warehouses, workshops, retail spaces, and offices. These floors provide superior strength, slip resistance, and long-lasting performance."
      },
      {
        "type": "p",
        "text": "We offer decorative epoxy flooring options , including metallic finishes, flake systems, and custom colors. These stylish coatings create modern, visually appealing floors that combine aesthetics with durability."
      },
      {
        "type": "p",
        "text": "Proper preparation is key to long-lasting epoxy floors. Our team handles surface preparation, crack repairs, grinding, and resurfacing to ensure strong adhesion and a smooth, professional finish."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "p",
        "text": "Expert Installation: Skilled professionals experienced in advanced epoxy flooring techniques. ✨"
      },
      {
        "type": "p",
        "text": "High-Performance Materials: Premium epoxy coatings designed for durability and long-term protection."
      },
      {
        "type": "p",
        "text": "Custom Design Options: Variety of colors, textures, and finishes to match your style and space."
      },
      {
        "type": "p",
        "text": "Reliable & Efficient Service: Projects completed on time with attention to detail and quality."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/epoxy-services/"
  },
  {
    "slug": "tree-cutting-services-page",
    "name": "Tree Cutting Services page",
    "group": "Concrete",
    "intro": "At MRE Developments , we provide professional tree cutting and tree removal services designed to keep your property safe, clean, and well-maintained. Our experienced team specializes in safe tree removal, tree trimming, branch cutting, and land clearing for residential and commercial properties. Whether you need to remove hazardous trees, clear space for construction, or manage overgrown branches, we use professional equipment and proven techniques to complete every job efficiently and safely. With a strong focus on safety, precision, and property protection , we deliver reliable tree cutting solutions that enhance curb appeal, improve safety, and support healthy landscape maintenance .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf1-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf9-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf10-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf13-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf16-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf9.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf10.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf13.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/rf16.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ku8.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Tree Cutting Services"
      },
      {
        "type": "p",
        "text": "At MRE Developments , we provide safe and efficient tree removal for residential and commercial properties. Our team carefully removes hazardous, damaged, or unwanted trees while protecting nearby structures and landscaping."
      },
      {
        "type": "p",
        "text": "Regular trimming and pruning help maintain healthy trees and a well-kept landscape. We remove overgrown or weak branches to improve tree health, safety, and the overall appearance of your property."
      },
      {
        "type": "p",
        "text": "Our team offers professional land clearing services to prepare your property for construction, landscaping, or outdoor improvements. We efficiently remove trees, brush, and debris to create a clean and ready-to-build space."
      },
      {
        "type": "p",
        "text": "Storms can leave dangerous trees or branches that threaten your property. We provide prompt tree cutting and removal services to eliminate hazards and restore safety to your home or business."
      },
      {
        "type": "p",
        "text": "After tree removal, we handle stump removal and thorough cleanup to leave your property neat and safe. Our team ensures the area is clear, level, and ready for landscaping or future projects."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "p",
        "text": "Skilled Professionals: Experienced team using professional equipment for safe tree cutting."
      },
      {
        "type": "p",
        "text": "Safety First: Careful techniques to protect your property and surrounding landscape."
      },
      {
        "type": "p",
        "text": "Reliable Service: Efficient, timely project completion with minimal disruption."
      },
      {
        "type": "p",
        "text": "Complete Solutions: From tree removal to cleanup, we handle every step with precision."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/tree-cutting-services-page/"
  },
  {
    "slug": "electrical-service",
    "name": "ELECTRICAL SERVICE",
    "group": "Structure & Trades",
    "intro": "At MRE Developments , we provide reliable and high-quality electrical services designed to keep your home safe, efficient, and fully functional . Whether you need new installations , upgrades , or troubleshooting , our skilled electricians deliver precise workmanship and dependable solutions . From lighting design and panel upgrades to wiring , outlets , and safety inspections , we handle every project with care and attention to detail . With a commitment to safety , performance , and customer satisfaction , MRE Developments ensures your electrical systems operate smoothly and meet all modern standards . Let us power your home with expertise you can trust .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/4-11-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/4-11-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/qa-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20220222_124851-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20220222_125115-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/qa-1-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tf2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tf3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tf5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/qa-2-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-14-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-12-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-11-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/qa-2-scaled-1.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-14-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-12-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-11-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/qa-2-scaled-2.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/4-11.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/1-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/2-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/qa.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20220222_124851.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20220222_125115.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/qa-1.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tf2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tf3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/tf5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/qa-2.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-14.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-12.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-11.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/1-14-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/2-12-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/3-11-1.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Electrical Services"
      },
      {
        "type": "h",
        "level": 2,
        "text": "Our Electrical Services"
      },
      {
        "type": "h",
        "level": 4,
        "text": "1. Full Electrical Installations"
      },
      {
        "type": "p",
        "text": "Whether you’re building a new home, renovating, or upgrading your space, MRE Developments provides complete electrical installation services. From wiring and panels to outlets and fixtures, we ensure every component is installed safely and efficiently, giving you a fully functional and reliable electrical system."
      },
      {
        "type": "h",
        "level": 4,
        "text": "2. Electrical Repairs and Troubleshooting"
      },
      {
        "type": "p",
        "text": "Our team handles all types of electrical issues with precision and care. From flickering lights and tripped breakers to more complex wiring problems, we quickly diagnose and resolve issues, restoring safety and functionality to your home or business."
      },
      {
        "type": "h",
        "level": 4,
        "text": "3. Lighting Installation and Upgrades"
      },
      {
        "type": "p",
        "text": "Enhance your space with professional lighting solutions. We install and upgrade indoor and outdoor lighting, including ambient, task, and accent lighting, ensuring both style and efficiency. Our goal is to create lighting that is safe, functional, and visually appealing."
      },
      {
        "type": "h",
        "level": 4,
        "text": "4. Electrical Panel Upgrades"
      },
      {
        "type": "p",
        "text": "Ensure your home’s electrical system meets modern demands with panel upgrades. We replace outdated or overloaded panels, improving safety, performance, and energy efficiency while reducing the risk of electrical hazards."
      },
      {
        "type": "h",
        "level": 4,
        "text": "5. Wiring and Rewiring Services"
      },
      {
        "type": "p",
        "text": "Whether for new construction or older homes, our wiring and rewiring services guarantee safe, efficient, and code-compliant electrical systems. We use high-quality materials and expert techniques to provide long-lasting results."
      },
      {
        "type": "h",
        "level": 4,
        "text": "6. Outlet and Switch Installation"
      },
      {
        "type": "p",
        "text": "From basic outlets to advanced switch systems, we install and upgrade electrical points throughout your home. Our installations are designed for safety, accessibility, and convenience, tailored to your specific needs."
      },
      {
        "type": "h",
        "level": 4,
        "text": "7. Safety Inspections and Code Compliance"
      },
      {
        "type": "p",
        "text": "MRE Developments conducts thorough electrical safety inspections to identify potential hazards and ensure your system meets all local codes and regulations. Our priority is protecting your home, family, and investment."
      },
      {
        "type": "h",
        "level": 4,
        "text": "8. Smart Home Electrical Solutions"
      },
      {
        "type": "p",
        "text": "Upgrade your home with smart technology, including automated lighting, thermostats, security systems, and more. Our team integrates modern solutions that combine convenience, efficiency, and control at your fingertips."
      },
      {
        "type": "h",
        "level": 4,
        "text": "9. Outdoor and Landscape Lighting"
      },
      {
        "type": "p",
        "text": "Enhance your exterior spaces with professional outdoor lighting. From security lights to decorative landscape illumination, we create safe, functional, and visually striking outdoor environments."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Permits, Inspections & Code Compliance"
      },
      {
        "type": "p",
        "text": "Navigating permits and inspections can be complex—but we handle it all for you."
      },
      {
        "type": "p",
        "text": "Our team ensures:"
      },
      {
        "type": "list",
        "items": [
          "Electrical permits are obtained",
          "All installations meet National building codes",
          "Required inspections are completed and approved"
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments for your electrical work?"
      },
      {
        "type": "list",
        "items": [
          "End-to-End Service – From electrical repairs to full system electrical installations",
          "Code-Compliant Work – Built to meet or exceed building codes & safety codes",
          "Experienced Team – Certified Electricians",
          "Integrated Solutions – Seamless coordination with the rest of your construction project",
          "Reliable & Efficient – On-time service without compromising quality"
        ]
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/electrical-service/"
  },
  {
    "slug": "framing-services",
    "name": "Framing Services",
    "group": "Structure & Trades",
    "intro": "At MRE Developments , we provide professional framing services that create the strong structural foundation for every successful building project. Our skilled team specializes in framing for multi-family homes, single-family homes, and custom homes , ensuring each structure is built with precision, strength, and long-term durability. From new construction and home additions to renovation projects, We carefully frame walls, floors, and roof systems using high-quality materials and precise measurements . With a commitment to expert craftsmanship and structural integrity , we deliver framing solutions that ensure safe construction and seamlessly align with your property’s design and architectural vision .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi1-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_125407-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_125433-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_125735-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_130403-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174731-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174735-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174817-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174819-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174533-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174548-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174551-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174609-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175110-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175111-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175127-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175130-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/oi4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_125407.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_125433.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_125735.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/IMG_20190514_130403.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174731.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174735.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174817.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174819.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174533.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174548-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174551-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_174609-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175110.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175111.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175127.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/20180423_175130.jpg"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "At MRE Developments , we provide professional framing services for multi-family homes, single-family homes, and custom homes . Our experienced team constructs strong, precise structural frames that form the backbone of every successful residential project, ensuring durability, stability, and long-term performance."
      },
      {
        "type": "p",
        "text": "We specialize in custom home framing , carefully building structures that match unique architectural designs and layouts. Our team works closely with builders, architects, and homeowners to ensure every frame supports both the vision and structural requirements of the project."
      },
      {
        "type": "p",
        "text": "Our team installs structural wood framing for walls, floors, and roof systems using high-quality materials and proven construction techniques. This ensures a solid framework that supports the entire building while meeting safety standards and building codes."
      },
      {
        "type": "p",
        "text": "We provide interior framing services for room layouts, renovations, and remodeling projects. Whether you’re creating new living spaces, offices, or open-concept designs, we frame interiors with precision to support both functionality and design."
      },
      {
        "type": "p",
        "text": "Our team handles framing for home additions and renovation projects , ensuring new structures integrate seamlessly with the existing building. We focus on accurate measurements and structural integrity to deliver a safe and durable result."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "p",
        "text": "Expert Craftsmanship: Skilled framing professionals delivering precise structural work."
      },
      {
        "type": "p",
        "text": "Quality Materials: Strong, reliable lumber and framing materials for long-lasting support."
      },
      {
        "type": "p",
        "text": "Versatile Experience: Expertise in multi-family, single-family, and custom home framing projects."
      },
      {
        "type": "p",
        "text": "Reliable & Efficient Service: Framing projects completed on schedule with attention to detail and quality."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/framing-services/"
  },
  {
    "slug": "gas-services-page",
    "name": "Gas Services page",
    "group": "Structure & Trades",
    "intro": "At MRE Developments, we provide reliable, code-compliant gas services in Calgary designed to support everything from everyday residential repairs , full-scale renovations , and secondary suite construction to large commercial projects . Whether you’re dealing with an urgent issue or planning a major project , our team delivers efficient, high-quality solutions tailored to your property.",
    "hero": null,
    "gallery": [],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Gas Services"
      },
      {
        "type": "p",
        "text": "From minor repairs to complete system installations , we ensure every project meets Calgary’s building codes , safety standards , and permit requirements ."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Gas Services (Residential & Commercial)"
      },
      {
        "type": "p",
        "text": "We design and install Gas Line & Heating systems that align with your project layout, maximize efficiency, and meet all safety and building requirements. Gas for:"
      },
      {
        "type": "list",
        "items": [
          "Commercial Construction",
          "New Home Construction & Multifamily Construction",
          "Basement developments & legal secondary suites",
          "Garage suites & backyard suites",
          "Kitchen renovations",
          "Full home renovations"
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "1.Gas Line Installations"
      },
      {
        "type": "p",
        "text": "We provide safe, professional gas line installations for appliances, heating systems, and new developments. Every installation is completed to strict safety standards and fully compliant with local codes."
      },
      {
        "type": "h",
        "level": 4,
        "text": "2.Garage Heater Installations"
      },
      {
        "type": "p",
        "text": "Keep your garage warm and functional year-round with professionally installed gas heaters. Ideal for homeowners, workshops, and investment properties, these systems add comfort and usability to your space."
      },
      {
        "type": "h",
        "level": 4,
        "text": "3. Permits, Inspections & Code Compliance"
      },
      {
        "type": "p",
        "text": "Navigating permits and inspections can be complex—but we handle it all for you."
      },
      {
        "type": "p",
        "text": "Our team ensures:"
      },
      {
        "type": "list",
        "items": [
          "Gas permits are obtained",
          "All installations meet National building codes",
          "Required inspections are completed and approved"
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments for your Gas work?"
      },
      {
        "type": "list",
        "items": [
          "End-to-End Service – From gas line repairs to full system gas line installations",
          "Code-Compliant Work – Built to meet or exceed building codes & safety codes",
          "Experienced Team – Certified Gas Fitters",
          "Integrated Solutions – Seamless coordination with the rest of your construction project",
          "Reliable & Efficient – On-time service without compromising quality"
        ]
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/gas-services-page/"
  },
  {
    "slug": "kerdi-kit-shower-waterproofing-services",
    "name": "Kerdi Kit Shower Waterproofing Services",
    "group": "Structure & Trades",
    "intro": "At MRE Developments , we deliver professional Kerdi Kit shower waterproofing services designed to protect your bathroom from moisture damage while ensuring long-lasting durability and performance . Using the trusted Schluter Kerdi waterproofing system , our skilled team creates a fully sealed, leak-proof shower environment that prevents mold , water damage , and structural issues . From precise installation of the Kerdi membrane and shower tray to seamless integration with your tile design , we ensure every detail is completed with accuracy and care . With a strong commitment to quality craftsmanship , reliability , and modern waterproofing solutions , we create showers that are not only beautiful but built to perform for years to come.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de2-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de9.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk2-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk8.jpg"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "At MRE Developments , we specialize in full Kerdi shower system installation using the trusted Schluter Kerdi technology. From proper substrate preparation to final waterproof sealing, we ensure your shower is fully protected from leaks, moisture damage, and mold growth."
      },
      {
        "type": "p",
        "text": "We design waterproof shower systems tailored to your bathroom layout and style preferences. Our team carefully plans the placement of membranes, drains, and shower trays to ensure optimal drainage, durability, and seamless tile installation."
      },
      {
        "type": "p",
        "text": "Our experts install high-performance Kerdi waterproof membranes to create a fully sealed barrier behind your shower walls and floors. This advanced waterproofing system prevents water penetration and protects the structural integrity of your bathroom."
      },
      {
        "type": "p",
        "text": "We install precision-fit Kerdi shower trays and integrated drain systems to ensure efficient water flow and long-term performance. Proper installation helps eliminate pooling water and supports a durable, leak-proof shower foundation."
      },
      {
        "type": "p",
        "text": "If you’re renovating an existing bathroom, we upgrade your shower with modern Kerdi waterproofing solutions. Our team removes outdated materials, reinforces structures if needed, and installs a reliable waterproof system designed to last for years."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "p",
        "text": "Skilled Craftsmanship: Experienced professionals trained in advanced shower waterproofing techniques."
      },
      {
        "type": "p",
        "text": "Premium Waterproof Systems: High-quality Schluter Kerdi materials for superior moisture protection."
      },
      {
        "type": "p",
        "text": "Precision Installation: Careful attention to detail for a fully sealed, leak-proof shower system."
      },
      {
        "type": "p",
        "text": "Client-Focused Approach: Clear communication and results that match your vision."
      },
      {
        "type": "p",
        "text": "Reliable Completion: Efficient project delivery with minimal disruption to your home."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/kerdi-kit-shower-waterproofing-services/"
  },
  {
    "slug": "plumbing-services",
    "name": "Plumbing Services",
    "group": "Structure & Trades",
    "intro": "At MRE Developments, we provide reliable, code-compliant plumbing services in Calgary designed to support everything from everyday residential repairs , full-scale renovations , and secondary suite construction to large commercial projects . Whether you’re dealing with an urgent issue or planning a major project , our team delivers efficient, high-quality solutions tailored to your property.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-16-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-16-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-14-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-12-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/Plumber-linework-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/4-22-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/5-6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/6-6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-17-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-15-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-13-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Plumber-linework-scaled-1.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-18-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-16-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-14.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-16-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-14-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-12-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Plumber-linework-scaled-4.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/4-22-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/5-6-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/6-6-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-16-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-14-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-12-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Plumber-linework-scaled-3.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-18-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-16-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-14-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-16.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-14.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-12.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/Plumber-linework.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/4-22.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/5-6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/6-6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-17.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-15.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-13.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-18.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-16.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-16-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-14-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-12-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/4-22-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/5-6-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/6-6-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-16-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-14-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-12-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/1-18-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/2-16-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/3-14-1.jpg"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "From minor repairs to complete system installations , we ensure every project meets Calgary’s building codes , safety standards , and permit requirements ."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Our Calgary Plumbing Services (Residential & Commercial)"
      },
      {
        "type": "p",
        "text": "We design and install complete plumbing systems that align with your project layout, maximize efficiency, and meet all safety and building requirements…Plumbing for:"
      },
      {
        "type": "list",
        "items": [
          "Commercial Construction",
          "New Home Construction & Multifamily Construction",
          "Basement developments & legal secondary suites",
          "Garage suites & backyard suites",
          "Kitchen renovations",
          "Bathroom renovations",
          "Full home renovations"
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "1. Plumbing Repairs & Drain Solutions"
      },
      {
        "type": "p",
        "text": "Dealing with leaks, clogs, or drainage issues? We provide fast, effective plumbing repairs to restore your system and prevent further damage. From small leaks to major blockages, our team diagnoses and resolves issues with long-term reliability in mind."
      },
      {
        "type": "h",
        "level": 4,
        "text": "2. Hot Water Heater Repair & Replacement"
      },
      {
        "type": "p",
        "text": "Ensure consistent hot water with our repair and replacement services. Whether your unit needs maintenance or a full upgrade, we install energy-efficient systems designed for performance and longevity."
      },
      {
        "type": "h",
        "level": 4,
        "text": "3. Poly B Replacement"
      },
      {
        "type": "p",
        "text": "Older homes in Calgary often contain Poly B plumbing, which can lead to leaks and costly damage over time. We safely replace outdated piping with modern, durable materials—protecting your home and increasing its long-term value."
      },
      {
        "type": "h",
        "level": 4,
        "text": "4. Emergency Plumbing Services"
      },
      {
        "type": "p",
        "text": "Plumbing emergencies can happen anytime. Our rapid-response team is available to handle urgent issues like burst pipes, major leaks, and system failures—minimizing damage and restoring functionality quickly."
      },
      {
        "type": "h",
        "level": 4,
        "text": "5. Permits, Inspections & Code Compliance"
      },
      {
        "type": "p",
        "text": "Navigating permits and inspections can be complex—but we handle it all for you."
      },
      {
        "type": "p",
        "text": "Our team ensures:"
      },
      {
        "type": "list",
        "items": [
          "Plumbing permits are obtained",
          "All installations meet National building codes",
          "Required inspections are completed and approved"
        ]
      },
      {
        "type": "h",
        "level": 4,
        "text": "Why Choose MRE Developments for your Plumbing work?"
      },
      {
        "type": "list",
        "items": [
          "End-to-End Service – From plumbing repairs to full system plumbing installations",
          "Code-Compliant Work – Built to meet or exceed building codes & safety codes",
          "Experienced Team – Certified Plumbers",
          "Integrated Solutions – Seamless coordination with the rest of your construction project",
          "Reliable & Efficient – On-time service without compromising quality"
        ]
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/plumbing-services/"
  },
  {
    "slug": "roofing-services",
    "name": "ROOFING SERVICES",
    "group": "Structure & Trades",
    "intro": "At MRE Developments , we specialize in providing durable, high-quality roofing solutions designed to protect and enhance your home . Whether you require a full roof replacement , professional repairs , or custom roofing installations , our skilled team in Calgary delivers exceptional workmanship and reliable results . From asphalt shingles to metal roofing and everything in between, we ensure your roof is built to withstand the elements while elevating your home’s curb appeal . Trust us to keep your property safe, secure, and looking its best with roofing services that combine strength , style , and long-lasting performance .",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251105_092650-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251105_092650-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251105_093530-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251105_092404-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251112_161412-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251112_161240-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251112_162314-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251105_092650.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251105_093530.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251105_092404.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251112_161412.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251112_161240.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20251112_162314.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 4,
        "text": "Our Roofing Services"
      },
      {
        "type": "p",
        "text": "Whether your roof has reached the end of its lifespan or sustained significant damage, MRE Developments provides complete roof replacement services. From initial inspection to final installation, we handle every step with precision and care. Our team ensures your new roof is durable, weather-resistant, and built to protect your home for years to come."
      },
      {
        "type": "p",
        "text": "Even minor roofing issues can lead to major problems if left unaddressed. Our expert technicians offer reliable repair and maintenance services to fix leaks, damaged shingles, flashing issues, and more. We work efficiently to restore your roof’s integrity while preventing future complications."
      },
      {
        "type": "p",
        "text": "Building a new home or addition? MRE Developments provides professional roofing installations tailored to your design, budget, and material preferences. From asphalt shingles and metal roofing to flat roof solutions, we help you choose the best option for long-term performance and curb appeal."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/roofing-services/"
  },
  {
    "slug": "structural-services",
    "name": "STRUCTURAL SERVICES",
    "group": "Structure & Trades",
    "intro": "Structural Renovations & Load-Bearing Wall Removal",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q1-2-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q1-2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/xz6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260401_132755-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260420_115515-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260428_125825-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260428_125843-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260520_111845-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260527_103109-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260527_111903-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260531_195818-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q1-2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/q4-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/v4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/ee8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/xz6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/xz8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260401_132755.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260420_115515.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260428_125825.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260428_125843.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260520_111845.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260527_103109.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260527_111903.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/06/20260531_195818.jpg"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "Create The Open-Concept Home You’ve Always Wanted"
      },
      {
        "type": "p",
        "text": "Many older homes were built with separated rooms, narrow openings, and walls that limit natural light and visibility throughout the home. Today’s homeowners want something different. They want open kitchens, larger living spaces, improved functionality , and a layout that better supports modern living ."
      },
      {
        "type": "p",
        "text": "At MRE Developments, we help homeowners safely transform their spaces through professional structural renovations, load-bearing wall removal, beam installation, and engineered structural modifications."
      },
      {
        "type": "p",
        "text": "Whether you’re opening up your main floor, combining rooms, or completely reimagining your home’s layout, our team manages the process from planning and engineering through construction and final inspections."
      },
      {
        "type": "p",
        "text": "When structural work is done correctly, your renovation doesn’t just look better."
      },
      {
        "type": "p",
        "text": "It performs better too."
      },
      {
        "type": "h",
        "level": 4,
        "text": "Structural Renovation Services"
      },
      {
        "type": "p",
        "text": "Open up kitchens, dining rooms, living areas, and basements by safely removing structural walls and replacing them with properly engineered support systems."
      },
      {
        "type": "p",
        "text": "Engineered beams transfer structural loads safely while creating the large open spaces homeowners want. We install LVL, engineered wood, and steel beam systems designed specifically for your project."
      },
      {
        "type": "p",
        "text": "Every beam requires a properly designed load path. Our team installs structural posts, columns, and support systems that safely transfer loads to the foundation below."
      },
      {
        "type": "p",
        "text": "Transform compartmentalized floorplans into bright, modern spaces that improve flow, visibility, and everyday living."
      },
      {
        "type": "p",
        "text": "Creating a legal suite? Renovating your basement? Reconfiguring rooms? We perform structural modifications that help maximize functionality while maintaining structural integrity."
      },
      {
        "type": "p",
        "text": "Structural modifications often require engineering and municipal approvals. We coordinate drawings, permits, inspections, and construction so your project proceeds smoothly from start to finish."
      },
      {
        "type": "p",
        "text": "Removing the wrong wall can have serious consequences."
      },
      {
        "type": "p",
        "text": "Structural loads must be properly identified, transferred, and supported."
      },
      {
        "type": "p",
        "text": "That’s why every structural renovation should begin with proper planning, engineering, and experienced execution."
      },
      {
        "type": "p",
        "text": "At MRE Developments, we work with qualified engineers and proven construction methods to ensure every project is completed safely, professionally, and in accordance with applicable building requirements."
      },
      {
        "type": "p",
        "text": "Just properly designed structural solutions built to perform for decades."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Homeowners Choose MRE Developments"
      },
      {
        "type": "p",
        "text": "Every structural modification starts with understanding how loads travel through the building and how they must be supported after construction."
      },
      {
        "type": "p",
        "text": "End-To-End Project Management"
      },
      {
        "type": "p",
        "text": "We coordinate engineering, permits, inspections, structural work, and finishing trades under one roof."
      },
      {
        "type": "p",
        "text": "Structural work becomes part of the foundation of your renovation. We focus on accuracy, durability, and long-term performance."
      },
      {
        "type": "p",
        "text": "Open-concept layouts remain one of the most desirable improvements homeowners can make, often improving both everyday enjoyment and resale appeal."
      },
      {
        "type": "p",
        "text": "Structural renovations require more than construction experience."
      },
      {
        "type": "p",
        "text": "They require planning, engineering, and a clear understanding of how buildings work."
      },
      {
        "type": "p",
        "text": "Whether you’re removing a load-bearing wall, installing a structural beam, opening up your floorplan, or planning a major renovation, MRE Developments provides the expertise needed to complete the project safely and professionally."
      },
      {
        "type": "p",
        "text": "Contact us today to discuss your structural renovation project."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/structural-services/"
  },
  {
    "slug": "stucco-services",
    "name": "Stucco Services",
    "group": "Structure & Trades",
    "intro": "At MRE Developments , we provide professional stucco services designed to enhance the durability, protection, and appearance of your property. Our experienced team specializes in single-family, multi-family, and commercial stucco installation , along with repairs, foundation crack sealing, and parging. We also offer California textured stucco, smooth flat stucco finishes, and woodpecker damage repairs with protective proofing . With quality materials and skilled craftsmanship, we deliver long-lasting stucco solutions that improve both the strength and curb appeal of your building",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu1-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uu8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/04/uu7.jpg",
      "https://calgary.mredevelopments.com/wp-content/uploads/2026/04/uu8.jpg"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "At MRE Developments , we provide professional stucco installation for single-family homes , delivering durable, weather-resistant finishes that enhance both protection and curb appeal. Our skilled team ensures precise application for a long-lasting and attractive exterior."
      },
      {
        "type": "p",
        "text": "We specialize in multi-family stucco installation for apartments, townhouses, and residential complexes. Our team applies high-quality stucco systems that offer durability, insulation, and a clean, professional appearance for large residential properties."
      },
      {
        "type": "p",
        "text": "Our commercial stucco services provide strong and visually appealing exterior finishes for offices, retail buildings, and commercial spaces. We ensure every installation meets structural requirements and delivers a professional, long-lasting finish."
      },
      {
        "type": "p",
        "text": "Woodpecker damage can weaken stucco surfaces and structures. Our team provides woodpecker repairs and preventive proofing solutions to repair damaged areas and help protect your property from future damage."
      },
      {
        "type": "p",
        "text": "We offer a variety of stucco finishes , including California textured stucco and smooth flat stucco , allowing you to choose the style that best complements your property’s design while maintaining durability and weather resistance."
      },
      {
        "type": "p",
        "text": "Our foundation crack repair services address structural cracks that may allow moisture to penetrate walls or foundations. We carefully repair and seal damaged areas to maintain the strength and stability of your building."
      },
      {
        "type": "p",
        "text": "We provide professional parging services to create a smooth protective coating over concrete or masonry surfaces. Parging improves the appearance of foundation walls while adding an extra layer of protection against weather and moisture."
      },
      {
        "type": "p",
        "text": "Our stucco repair services restore damaged, cracked, or aging stucco surfaces. We carefully match textures and finishes to blend repairs seamlessly with the existing exterior."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "p",
        "text": "Expert Craftsmanship: Skilled professionals delivering high-quality stucco finishes."
      },
      {
        "type": "p",
        "text": "Durable Materials: Premium stucco systems designed for long-term performance."
      },
      {
        "type": "p",
        "text": "Versatile Experience: Expertise in residential, multi-family, and commercial stucco projects."
      },
      {
        "type": "p",
        "text": "Reliable Service: Efficient project completion with attention to detail and lasting results."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/stucco-services/"
  },
  {
    "slug": "flooring-services-page",
    "name": "Flooring Services page",
    "group": "Finishes",
    "intro": "At MRE Developments , we transform your interiors with expertly installed flooring solutions designed to enhance style, durability, and comfort. From elegant hardwood and modern tile to durable laminate and vinyl flooring, our skilled team ensures every installation is completed with precision and attention to detail. We carefully prepare each surface and seamlessly integrate new flooring with your home’s existing design to create a flawless finish. With a strong commitment to quality craftsmanship, premium materials, and customized solutions, we deliver flooring services that elevate the beauty, functionality, and value of your home.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg1-1-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj5-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj6-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj7-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj8-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk1-1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk2-1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk3-1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk5-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk6-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk7-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk8-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg2-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/gg4-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj2-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj4-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj5-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj6-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj7-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/jj8-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/sw8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk1-1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk2-1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk3-1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk4-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk5-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk6-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk7-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kk8-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd8.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Flooring Services"
      },
      {
        "type": "p",
        "text": "At MRE Developments , we provide professional marble flooring installation that adds elegance, durability, and timeless appeal to your home. Our team carefully installs and finishes marble floors to create a smooth, luxurious surface that enhances the beauty and value of your space."
      },
      {
        "type": "p",
        "text": "We install modern heated flooring systems designed to bring comfort and energy efficiency to your home. Ideal for bathrooms, kitchens, and living spaces, heated floors provide consistent warmth and a cozy environment during colder seasons."
      },
      {
        "type": "p",
        "text": "Our epoxy flooring services offer a durable, low-maintenance, and visually appealing option for garages, basements, and commercial spaces. With strong resistance to stains, moisture, and wear, epoxy floors provide a sleek and long-lasting finish."
      },
      {
        "type": "p",
        "text": "We specialize in high-quality tile flooring installation , offering a wide range of styles, colors, and patterns. Whether you prefer ceramic, porcelain, or stone tiles, our team ensures precise installation that delivers both durability and a polished appearance."
      },
      {
        "type": "p",
        "text": "Our team handles flooring upgrades, repairs, and surface preparation to ensure every installation is stable and long-lasting. From leveling subfloors to replacing outdated materials, we make sure your new flooring performs beautifully for years to come."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "p",
        "text": "Skilled Craftsmanship: Experienced flooring professionals delivering precise and reliable installations."
      },
      {
        "type": "p",
        "text": "Premium Materials: High-quality marble, tiles, epoxy coatings, and heating systems for lasting performance."
      },
      {
        "type": "p",
        "text": "Client-Focused Approach: Clear communication and flooring solutions tailored to your style and needs."
      },
      {
        "type": "p",
        "text": "Efficient Project Completion: Flooring projects completed on time with minimal disruption to your home."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/flooring-services-page/"
  },
  {
    "slug": "painting",
    "name": "Painting",
    "group": "Finishes",
    "intro": "At MRE Developments , we offer comprehensive painting services tailored to meet the unique needs of our Calgary clientele . Our commitment to quality craftsmanship and exceptional customer service ensures that every project we undertake not only meets but exceeds expectations. Add the perfect finishing touch to your project with our expert painting services . Our team of professional painters will work closely with you to select the ideal colors and finishes for your home or business, delivering a beautiful, long-lasting result every time.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/4.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/mreyycpainting2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/mreyycpainting5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/mreyycpainting4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/mreyycpainting7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-1-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/20221202_132550-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/20221202_134003-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-2-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/A-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/B-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/C-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-3-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/mreyycpainting1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/mreyycpainting3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/20221202_133538-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-4-scaled.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-1.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/20221202_132550.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/20221202_134003.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-2.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/A.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/B.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/C.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-3.png",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/03/20221202_133538.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/05/Painter-final-4.png"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Painting Services"
      },
      {
        "type": "p",
        "text": "Our Painting Services Include:"
      },
      {
        "type": "list",
        "items": [
          "Interior Painting: Transform your living spaces with our meticulous interior painting services. Whether it’s a single room or an entire home, our team ensures a flawless finish that revitalizes your interiors.",
          "Exterior Painting: Enhance your property’s curb appeal with our durable exterior painting solutions. We use high-quality paints and materials to withstand Calgary’s diverse weather conditions, ensuring longevity and aesthetic appeal.",
          "Commercial Painting: Our expertise extends to commercial properties, where we deliver professional painting services with minimal disruption to your business operations."
        ]
      },
      {
        "type": "p",
        "text": "Why Choose M.R.E. Developments for Your Painting Needs?"
      },
      {
        "type": "list",
        "items": [
          "Experienced Professionals: Our team comprises skilled painters dedicated to delivering impeccable results on every project.",
          "Quality Materials: We prioritize the use of premium paints and materials, ensuring a lasting and vibrant finish.",
          "Customer Satisfaction: Our commitment to exceptional customer service has earned us high praise from our clients. For instance, one satisfied customer noted: homestars.com I hired MRE Development to paint the walkway and front terrace… the job is done very well, at a reasonable cost. I am very happy with the outcome.” homestars.com"
        ]
      },
      {
        "type": "p",
        "text": "Contact Us Today"
      },
      {
        "type": "p",
        "text": "Ready to transform your space with a fresh coat of paint? Contact M.R.E. Developments today to schedule a consultation and receive a personalized quote. Let us bring your vision to life with our expert painting services in Calgary."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/painting/"
  },
  {
    "slug": "tiling-services",
    "name": "Tiling Services",
    "group": "Finishes",
    "intro": "At MRE Developments , we provide professional tiling services designed to enhance the beauty, durability, and functionality of your spaces. From floors and walls to kitchens and bathrooms, our skilled team installs high-quality ceramic, porcelain, marble, and stone tiles with precision and attention to detail.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/1-12-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/1-12-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/2-11-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/3-10-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/4-21-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ll1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ll6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ll7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ll8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ss1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ss2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ss3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ss4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kkd1.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kkd2.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kkd3.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/kkd4.jpeg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd1-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/pp1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/pp2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/pp3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/pp4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de2-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de3-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de4-1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy2-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ii1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ii2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ii3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/ii4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/1-12.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/2-11.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/3-10.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/4-21.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd1-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd2-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/fd4-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/az4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de2-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de3-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/de4-1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy2.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/03/uy4.jpg"
    ],
    "blocks": [
      {
        "type": "p",
        "text": "We carefully prepare each surface to ensure a smooth, long-lasting finish that complements your home’s design . With a commitment to quality craftsmanship , premium materials , and customized layouts , we deliver tiling solutions that add style , strength , and value to your property."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Tiling Floor Services"
      },
      {
        "type": "p",
        "text": "At MRE Developments , we provide high-quality residential floor tiling services designed to enhance durability, style, and functionality. Our expert team installs beautiful and long-lasting tile floors for living rooms, kitchens, bathrooms, and hallways, creating surfaces that are both elegant and easy to maintain."
      },
      {
        "type": "p",
        "text": "We specialize in kitchen and bathroom tile flooring , delivering water-resistant and durable solutions that withstand daily use. Our precise installation ensures a clean, polished finish that improves both the appearance and practicality of these high-use spaces."
      },
      {
        "type": "p",
        "text": "Our team installs ceramic and porcelain tile flooring known for their strength, versatility, and modern appeal. These tiles are ideal for residential and commercial spaces, offering excellent resistance to moisture, stains, and heavy foot traffic."
      },
      {
        "type": "p",
        "text": "We offer decorative tile flooring solutions , including patterned layouts, mosaic designs, and custom tile arrangements. These creative installations add character and style while maintaining the durability and functionality of tile flooring."
      },
      {
        "type": "p",
        "text": "Proper preparation is essential for long-lasting tile floors. Our team handles surface leveling, subfloor preparation, tile replacement, and grout finishing to ensure a stable base and a smooth, professional installation."
      },
      {
        "type": "h",
        "level": 3,
        "text": "Why Choose MRE Developments?"
      },
      {
        "type": "p",
        "text": "Expert Installation: Skilled professionals experienced in precise tile flooring techniques. 🏡"
      },
      {
        "type": "p",
        "text": "Premium Materials: High-quality ceramic, porcelain, and stone tiles for durability and style."
      },
      {
        "type": "p",
        "text": "Custom Design Options: Wide variety of tile styles, patterns, and layouts to match your space."
      },
      {
        "type": "p",
        "text": "Reliable & Efficient Service: Projects completed on time with attention to detail and quality."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/tiling-services/"
  },
  {
    "slug": "demolition-service",
    "name": "Demolition Service",
    "group": "Exterior & Site",
    "intro": "At MRE Developments , we deliver safe and efficient demolition services for residential , commercial , and renovation projects . From interior strip-outs to full structural removal , our team uses modern equipment and controlled methods to minimize disruption and keep project timelines on track . We also handle debris removal and site preparation , ensuring your property is clean and ready for the next phase of construction.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-9-scaled.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-9-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-18-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/5-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/6-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/7-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/8-4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230613_153417-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230614_185839-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230614_195129-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/b5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-10-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-9-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-19-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-11-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-10-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-9-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-20-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u1-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u3-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u4-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u5-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u6-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u7-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u8-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/resized_12000x9000-scaled.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-9.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-18.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/5-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/6-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/7-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/8-4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230613_153417.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230614_185839.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/20230614_195129.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/b5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-10.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-9.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-19.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/1-11.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/2-10.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/3-9.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/4-20.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u1.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u3.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u4.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u5.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u6.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u7.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/u8.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2026/02/resized_12000x9000.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Demolition Services"
      },
      {
        "type": "h",
        "level": 3,
        "text": "Our Demolition Services"
      },
      {
        "type": "p",
        "text": "1. Residential Demolition Safely remove unwanted structures from your property, including garages, sheds, interior walls, kitchens, and full home demolitions. We ensure controlled work with minimal disruption to surrounding areas."
      },
      {
        "type": "p",
        "text": "2. Commercial Demolition Efficient demolition solutions for offices, retail spaces, and commercial buildings. Our team manages structural removal, interior strip-outs, and site clearing while maintaining strict safety standards and timelines."
      },
      {
        "type": "p",
        "text": "3. Partial Demolition & Interior Strip-Outs Perfect for renovation projects, we selectively remove walls, flooring, ceilings, and fixtures without affecting the structural integrity of the remaining space."
      },
      {
        "type": "p",
        "text": "4. Debris Removal & Site Preparation We handle all waste removal, recycling where possible, and prepare your site cleanly for the next phase of construction."
      },
      {
        "type": "p",
        "text": "Why Choose M.R.E Developments for Your Demolition Project?"
      },
      {
        "type": "list",
        "items": [
          "Safety-First Approach: Strict compliance with industry safety standards.",
          "Modern Equipment & Skilled Team: Efficient, precise demolition methods.",
          "Clean & Organized Worksites: Complete debris removal and site readiness.",
          "Reliable Timelines: Projects completed on schedule and within budget.",
          "Residential & Commercial Expertise: Solutions tailored to your project needs."
        ]
      },
      {
        "type": "p",
        "text": "Our Work Speaks for Itself Explore our portfolio of residential and commercial demolition projects. From small interior removals to full structural demolition, our workmanship ensures your site is safely cleared and ready for construction."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/demolition-service/"
  },
  {
    "slug": "dex-and-pergola-services",
    "name": "DEX AND PERGOLA SERVICES",
    "group": "Exterior & Site",
    "intro": "At MRE Developments , we build high-quality decks and pergolas that elevate your outdoor living space . Our Calgary team delivers custom designs , durable construction , and stylish finishes , creating comfortable, functional areas perfect for relaxing or entertaining . Let us transform your backyard into a beautiful, inviting extension of your home.",
    "hero": "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/sdfsd.jpg",
    "gallery": [
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/sdfsd.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180902-125936_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180902-125846_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180902-125800_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180719-191248_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180719-191330_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180719-191403_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180902-125732_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180902-125748_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/Screenshot_20180717-230656_Instagram.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180820_094057.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180724_232443.jpg",
      "https://pxachejytkihfjxqflmo.supabase.co/storage/v1/object/public/media/uploads/2025/11/20180724_063638.jpg"
    ],
    "blocks": [
      {
        "type": "h",
        "level": 2,
        "text": "Dex & Pergolas Services"
      },
      {
        "type": "h",
        "level": 2,
        "text": "Our Deck and Pergola Services"
      },
      {
        "type": "h",
        "level": 4,
        "text": "1. Full Deck Construction"
      },
      {
        "type": "p",
        "text": "Whether you’re building a new deck or replacing an existing one, MRE Developments offers complete deck construction services tailored to your home and lifestyle. From design and framing to finishing and railings, our team ensures your deck is built with durability, safety, and aesthetic appeal in mind—creating the perfect outdoor space for relaxation and entertainment."
      },
      {
        "type": "h",
        "level": 4,
        "text": "2. Custom Deck Design"
      },
      {
        "type": "p",
        "text": "Every outdoor space is unique, and your deck should reflect that. Our custom deck design services allow you to choose the layout, materials, and features that best suit your needs. We work closely with you to bring your vision to life, crafting a personalized outdoor area that blends seamlessly with your home and enhances your yard’s functionality."
      },
      {
        "type": "h",
        "level": 4,
        "text": "3. Pergola Design and Installation"
      },
      {
        "type": "p",
        "text": "Elevate your outdoor living area with a professionally designed and installed pergola. Whether you’re looking for shade, architectural interest, or a defined space for dining or lounging, our team creates beautiful, long-lasting pergolas that enhance both comfort and style. We offer a range of materials and design options to match your home’s aesthetic."
      },
      {
        "type": "h",
        "level": 4,
        "text": "4. Deck Repairs and Upgrades"
      },
      {
        "type": "p",
        "text": "Extend the lifespan of your outdoor space with expert deck repairs and upgrades. From replacing damaged boards to reinforcing structural components or adding new features like lighting or railings, we ensure your deck remains safe, sturdy, and visually appealing. Our team handles repairs of all sizes with precision and care."
      },
      {
        "type": "h",
        "level": 4,
        "text": "5. Outdoor Living Enhancements"
      },
      {
        "type": "p",
        "text": "MRE Developments also offers additional outdoor enhancements to elevate your space, including privacy screens, built-in seating, planters, and integrated lighting. These features add both function and charm, transforming your deck or pergola into a versatile and inviting outdoor retreat tailored to your lifestyle."
      }
    ],
    "sourceUrl": "https://calgary.mredevelopments.com/dex-and-pergola-services/"
  }
];

export const getServicePage = (slug) => SERVICE_PAGES.find((p) => p.slug === slug);
